export { apiFetch, tokenStore, ApiError, API_BASE_URL, subscribeSessionLost } from './client';
export { authApi } from './auth';
export { profileApi } from './profile';
export { userPreferencesApi } from './user-preferences';
export { billingApi } from './billing';
export { opportunitiesApi } from './auctions';
export { favoritesApi } from './favorites';
export { interestsApi } from './interests';
export { arrematacoesApi } from './arrematacoes';
export { scraperApi } from './scraper';
export { geoAnalysisApi } from './geo-analysis';
export {
  userOpportunityDocumentsApi,
  userOpportunityDocumentFullUrl,
} from './user-opportunity-documents';

export type { AuthUser } from './auth';
export type {
  UserProfile,
  PlanDto,
  UserPlanDto,
  UserPlanResponse,
  PlanUsageSnapshot,
  PlanQuotaCounter,
  InvoiceDto,
  InvoiceStatus,
  PlanUpsertPayload,
} from './profile';
export type { CheckoutSessionResponse } from './billing';
export type {
  BeAuction,
  AuctionDocumentAnalysis,
  AiDocumentAnalysisJob,
  AiAnalysisJobStatus,
  AuctionListResponse,
  AuctionStats,
  AuctionQueryParams,
  AuctionSortByApi,
  OnrCartorioCalculoResponse,
  GeocodeQueueMissingResult,
  GeocodeReprocessResult,
} from './auctions';
export { toAuctionSortByApi } from './auctions';
export type { BeFavorite } from './favorites';
export type { BeAuctionInterest } from './interests';
export type {
  BeArrematacao,
  BeCusto,
  BeVenda,
  RoiResult,
  StatusArrematado,
  CategoriaCusto,
} from './arrematacoes';
export type { ScraperRunReportBe } from './scraper';
export type {
  GeoAnalysisResult,
  GeoCategoryResult,
  GeoPlace,
  GeoAnalysisScores,
} from './geo-analysis';
export type { UserOpportunityDocument } from './user-opportunity-documents';
export type { UpdateUserPreferencesPayload } from './user-preferences';
